export default {"src":"/_next/static/media/QSR.8a7b0888.svg","height":18,"width":18};